const promoProductsList = [
    'SLS_119926', //Bella + Canvas Unisex Zip-up Hooded Sweatshirt
    'SLS_119946', //Cutter & Buck Men's Traverse Quarter-Zip Pullover
    'SLS_119948', //Cutter & Buck Women’s Traverse Quarter-Zip Pullover
    'SLS_119906', //Carhartt® Watch Cap 2.0 Knit Beanie
    'SLS_119899', //Flagship Cotton Crew Socks
    'SLS_119910', //Gildan Softstyle® Crewneck T-Shirt
    'SLS_119864', //Gildan® Heavy Blend™ Crewneck Sweatshirt
    'SLS_119905', //Nike Dri-FIT Perforated Performance Cap
    'SLS_119932', //Nike Men's Dri-FIT Micro Pique 2.0 Polo
    'SLS_119933', //Nike Women’s Dri-FIT Micro Pique 2.0 Polo
    'SLS_119912', //Port & Company® Crewneck Core Blend T-Shirt
    'SLS_119944', //Port Authority® Men’s Microfleece Half-Zip Pullover
    'SLS_119945', //Port Authority® Women's Microfleece Half-Zip Pullover
    'SLS_119943', //Puma Golf Men's Bandon Quarter-Zip Pullover
    'SLS_119942', //Puma Golf Women’s Bandon Quarter-Zip Pullover
    'SLS_119903', //Richardson 112 Snapback Trucker Hat
    'SLS_119936', //TravisMathew Men's Oceanside Solid Polo
    'SLS_119937', //TravisMathew Women's Oceanside Solid Polo
    'SLS_119913', //Under Armour Men's Hustle Hooded Sweatshirt
    'SLS_119914', //Under Armour Women’s Hustle Hooded Sweatshirt
    'SLS_119865', //Case Logic 16" Computer & Tablet Backpack
    'SLS_119891', //H2Go 28 oz. Surge Water Bottle
    'SLS_119873', //Pelican Porter™ 40 oz. Recycled Double Wall Stainless Steel Tumbler
    'SLS_119894', //Field & Co.® Cable Knit Sherpa Blanket  
    'SLS_119895', //Leeman Trellis Beanie & Scarf Gift Set 
    'SLS_119897', //Mrs. Fields® Mug, Cookies & Hot Chocolate Bomb Gift Set
    'SLS_119949', //Silhouette Candle with Leather Sleeve & Gift Box
    'SLS_119896', //Vinay Wine Tumbler, Cutting Board, Meat & Cheese Gift Set
    'SLS_119892', //Denton Soft-Touch Pen & Stylus
    'SLS_119868'  //High Sierra Outdoor Bluetooth Speaker & Wireless Power Bank
]

export default promoProductsList;